module.exports = __webpack_public_path__ + "img/calendar.8632f2ef.svg";